import React from "react";
import { motion } from "framer-motion";
import ExperienceCard from "../components/Cards/Experience";
import Tag from "../components/Tag";
import Section from "../components/Section";
import experienceData from "../data/experience.json";

const tagAnimateVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  animate: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.05 * i,
    },
  }),
};

/**
 * Renders experience content from JSON data.
 * Supports paragraphs and sections with headings and lists.
 */
function ExperienceContentRenderer({ content }) {
  if (!content || !content.sections) return null;

  return (
    <div>
      {content.sections.map((section, index) => {
        if (section.type === "paragraph") {
          return (
            <p key={index} className="mb-4">
              {section.text}
            </p>
          );
        }

        if (section.type === "section") {
          return (
            <div key={index} className="mb-4">
              {section.heading && (
                <h2 className="text-lg mb-4">{section.heading}</h2>
              )}
              {section.items && (
                <ul className="pl-4 list-disc list-outside">
                  {section.items.map((item, itemIndex) => (
                    <li key={itemIndex}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          );
        }

        return null;
      })}
    </div>
  );
}

/**
 * Experience section component that displays all work experiences from JSON data.
 * Each experience is rendered using the ExperienceCard component with animated tags.
 */
function Experience() {
  return (
    <Section id="experience" title="Experience">
      {experienceData.map((experience, index) => (
        <ExperienceCard
          key={index}
          from={experience.from}
          to={experience.to}
          company={experience.company}
          title={experience.title}
        >
          <div>
            <ExperienceContentRenderer content={experience.content} />
            <div className="mt-2 flex flex-wrap">
              {experience.tags.map((tag, i) => (
                <motion.div
                  key={i}
                  variants={tagAnimateVariants}
                  initial="initial"
                  whileInView="animate"
                  viewport={{
                    once: true,
                  }}
                  custom={i}
                >
                  <Tag tag={tag} />
                </motion.div>
              ))}
            </div>
          </div>
        </ExperienceCard>
      ))}
    </Section>
  );
}

export default Experience;
